import _ from 'lodash';

import { adminClient as apolloClient } from '@/store/apollo';

import PlatformSettingsGql from '@/store/graphql/system/queries/PlatformSettings.gql';
import SavePlatformSettingsGql from '@/store/graphql/system/mutations/SavePlatformSettings.gql';

/**
 * A row the screen staged carries a NEGATIVE placeholder id so its table can key
 * on it before the server has given it a real one. The mutation reads "no id" as
 * "create", so the placeholder is dropped on the way out.
 */
const stripStagedIds = (rows) => (rows || []).map((row) => (Number(row.id) < 0 ? _.omit(row, 'id') : row));

export default {
    /** Everything the platform screen shows, in one read. */
    fetchPlatformSettings: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({ query: PlatformSettingsGql, fetchPolicy: 'network-only' })
                .then(({ data }) => resolve(data.PlatformSettings))
                .catch((err) => reject(err));
        }),

    /**
     * ...and in one write. Every argument is optional and an omitted one
     * changes nothing, so the page sends only what its form holds.
     */
    savePlatformSettings: (settings) =>
        new Promise((resolve, reject) => {
            const variables = _.removeDeepByKey(_.cloneDeep(settings), '__typename');

            if (variables.messagePresets) {
                variables.messagePresets = stripStagedIds(variables.messagePresets);
            }

            apolloClient
                .mutate({ mutation: SavePlatformSettingsGql, variables })
                .then(({ data }) => resolve(data.SavePlatformSettings))
                .catch((err) => reject(err));
        }),
};
